import { action } from 'typesafe-actions';

import { DecisionListActionsEnum } from '../enums/DecisionListActionsEnum';
import { IDecisionListItem } from '../interfaces/IDecisionListItem';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';
import { IDecisionListFilterParams } from '../interfaces/IDecisionListFilterParams';

export const decisionListInitPage = () => action(DecisionListActionsEnum.DECISION_LIST_INIT_PAGE);
export const decisionListRemoveDecisions = (ids: number[]) =>
  action(DecisionListActionsEnum.DECISION_LIST_REMOVE_DECISIONS, { ids });

export const decisionListSetSearchValue = (searchValue = '', filterParam?: IDecisionListFilterParams) =>
  action(DecisionListActionsEnum.DECISION_LIST_SET_SEARCH_VALUE, { searchValue, filterParam });
export const decisionListGetData = () => action(DecisionListActionsEnum.DECISION_LIST_GET_DATA);
export const decisionListGetDataNextPage = () => action(DecisionListActionsEnum.DECISION_LIST_GET_DATA_NEXT_PAGE);
export const decisionListSetData = (
  data: IDecisionListItem[],
  page: number,
  pageCount: number,
  totalCount: number,
  rejected: number,
) => action(DecisionListActionsEnum.DECISION_LIST_SET_DATA, { data, page, pageCount, totalCount, rejected });
export const decisionListSetOrder = (order: string | null) =>
  action(DecisionListActionsEnum.DECISION_LIST_SET_ORDER, { order });
export const decisionListGetDecisionSelectOptions = (
  searchValue: string,
  callback: (options: ISelectOption[]) => void,
) => action(DecisionListActionsEnum.DECISION_LIST_GET_DECISION_SELECT_OPTIONS, { searchValue, callback });
export const decisionListFindDecision = (filterParam: IDecisionListFilterParams, size?: number) =>
  action(DecisionListActionsEnum.DECISION_LIST_FIND_DECISION, { filterParam, size });
export const decisionListSetFindData = (findData: IDecisionListItem[]) =>
  action(DecisionListActionsEnum.DECISION_LIST_SET_FIND_DATA, { findData });
